import utagLinkGeneric from './utagLinkGeneric';

function utagLinkRoomViewer (eventCategory = 'Room Viewer') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkRoomViewer;
